import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { ButtonComponent } from "../ButtonComponent";
import { app } from "../../Frame/App";
import { ListView } from "./ListView";
import { Constants } from "../../Common/constants";

export interface IListItemInternalComponentProps {
    model?: any;
}

export type ListItemProps = {
    model: any;
    displayProperty: string;

    /** optional boolean model field to get/set checked state */
    checkedProperty: string;
    idProperty?: string;
    parentList: ListView;

    getDisplayNameAction?: (model: any) => string;

    allowSelect?: boolean;

    allowDelete?: boolean;
    hasIsDeleted?: boolean;
    deleteItemAction?: (model: any) => void;

    selected?: boolean;

    searchTerm?: string;

    postDeleteEvent?: () => void;


    listItemInternalComponentType?: any;
    listItemInternalComponentProps?: any;
}

export class ListItem extends JSXComponent {
    props: ListItemProps;

    constructor(props: ListItemProps) { super(props); }

    internalComponent: any;

    deleteItem = () => {
        app.destroyDomElements(this.element);
        this.element.remove();

        if (this.props.parentList) {
            // Remove instance of listItem
            this.props.parentList.items.splice(this.props.parentList.items.indexOf(this), 1);

            if (!this.props.hasIsDeleted) {
                // Remove model from parent model
                this.props.parentList.props.model.splice(this.props.parentList.props.model.indexOf(this.props.model), 1);
            }
        }

        if (this.props.deleteItemAction) {
            this.props.deleteItemAction(this.props.model);
        }

        if (this.props.postDeleteEvent) this.props.postDeleteEvent();
    }

    handleCheckboxChange = (event: Event) => {
        //console.log(this.props.parentList.props.selectedIds);

        //event.preventDefault();
        document.getSelection().removeAllRanges();

        // TODO Prüfen, ob das mit dem end so stimmt.

        let target = event.target as HTMLInputElement;
        this.props.selected = target.checked;

        if (this.props.checkedProperty) {
            this.props.model[this.props.checkedProperty] = this.props.selected = target.checked;
        }

        if (this.props.parentList.props.selectedIds && this.props.parentList.props.updateSelectedIds) {
            console.log("selected Ids after click:")
            console.log(this.props.parentList.getSelectedIds());

            console.log("selectedIds.length:");
            console.log(this.props.parentList.props.selectedIds.length)
            this.props.parentList.props.selectedIds.splice(0, this.props.parentList.props.selectedIds.length, ...this.props.parentList.getSelectedIds());
        }

        if (this.props.parentList.props.selectedStringIds && this.props.parentList.props.updateSelectedIds) {
            this.props.parentList.props.selectedStringIds.splice(0, this.props.parentList.props.selectedStringIds.length, ...this.props.parentList.getSelectedStringIds());
        }

        if ((event as MouseEvent).shiftKey == true && this.props.parentList) {

            let start = this.props.parentList.items.indexOf(this.props.parentList.lastClickedItem);
            let end = this.props.parentList.items.indexOf(this);

            let subset = this.props.parentList.items
                .filter(i => !i.getDisabled())
                .slice(Math.min(start, end), Math.max(start, end) + 1);
            for (let item of subset) {
                item.check();
            }

            console.log("lastClickedItem: " + this.props.parentList.items.indexOf(this.props.parentList.lastClickedItem));
            console.log("this item: " + this.props.parentList.items.indexOf(this));

        }
        this.props.parentList.lastClickedItem = this;

       // console.log(this.props.parentList.props.selectedIds);
    }

    disable = () => {
        let deleteButton = this.element.querySelector(".content-delete-button") as HTMLDivElement;
        if (deleteButton) {
            deleteButton.removeEventListener("click", this.deleteItem);
            deleteButton.classList.add(Constants.cssClass_greyedOut);
        }

        let checkbox = this.element.querySelector("input[type='checkbox']") as HTMLInputElement;
        if (checkbox) {
            checkbox.disabled = true;
        }
    }

    public getDisabled = () => {
        let checkbox = this.element.querySelector("input[type='checkbox']") as HTMLInputElement;
        if ((checkbox && checkbox.disabled) || !checkbox) return true;
        return false;
    }

    enable = () => {
        let deleteButton = this.element.querySelector(".content-delete-button") as HTMLDivElement;
        if (deleteButton) {
            deleteButton.addEventListener("click", this.deleteItem);
            deleteButton.classList.remove(Constants.cssClass_greyedOut);
        }
        let checkbox = this.element.querySelector("input[type='checkbox']") as HTMLInputElement;
        if (checkbox) {
            checkbox.disabled = false;
            checkbox.removeAttribute("disabled");
        }
    }

    check = () => {
        let checkbox = this.element.querySelector("input[type='checkbox']") as HTMLInputElement;
        if (checkbox) {
            checkbox.checked = this.props.selected = this.props.model[this.props.checkedProperty] = true;
        }
    }

    element: HTMLElement;

    getDisplayName = () => {
        let displayName: string;

        if (this.props.getDisplayNameAction) {
            displayName = this.props.getDisplayNameAction(this.props.model);
        }
        else {
            displayName = this.props.model[this.props.displayProperty];
        }

        if (this.props.searchTerm && this.props.searchTerm != "") {
            let start = displayName.toLocaleLowerCase().indexOf(this.props.searchTerm.toLocaleLowerCase());
            let length = this.props.searchTerm.length;
            displayName = displayName.substring(0, start)
                + `<span class="highlighted">${displayName.substring(start, start + length)}</span>`
                + displayName.substring(start + length);
        }

        let nameElement = this.element.querySelector(".item-element.name-container") as HTMLDivElement;
        nameElement.innerHTML = displayName;
    }


    render() {
        if (!this.props.idProperty) this.props.idProperty = "id";

        let guid = app.createGuid();

        if (this.props.listItemInternalComponentType) {
            let internalProps: IListItemInternalComponentProps = {
                model: this.props.model
            };

            // Copy the provided internal props to the iternal component props.
            if (this.props.listItemInternalComponentProps) {
                for (let key in this.props.listItemInternalComponentProps) {
                    internalProps[key] = this.props.listItemInternalComponentProps[key];
                }
            }

            this.internalComponent = new this.props.listItemInternalComponentType(internalProps);
        }

        this.element = <li className="list-group-item flex flex-row">
            {this.props.allowSelect
                ? < div className="checkbox-container item-element form-group-no-margin form-group">
                    <div className="form-check form-check-no-padding">
                        <input type="checkbox"
                            name={guid}
                            className="form-check-input"
                            id={guid}
                        />
                        <label className="form-check-label" for={guid}></label>
                    </div>
                </div>
                : []}

            {this.props.listItemInternalComponentType
                ? this.internalComponent.render()
                : <div className="item-element name-container" />}

            {this.props.allowDelete
                ? <div className="item-element delete-button-container">
                    <ButtonComponent
                        additionalCssClasses="icon-hover icon-edit fal fa-trash-alt pointer content-delete-button"
                        action={this.deleteItem}
                        altText={Resources.Common.delete} />
                </div>
                : []}
        </li>

        if (!this.props.listItemInternalComponentType) {
            this.getDisplayName();
        }

        let checkboxElement = this.element.querySelector(".checkbox-container input") as HTMLInputElement;
        if (checkboxElement) {
            if ((this.props.checkedProperty && this.props.model[this.props.checkedProperty])
                || this.props.selected
                || (this.props.parentList.props.selectedIds
                    && this.props.parentList.props.selectedIds.indexOf(this.props.model[this.props.idProperty]) > -1)
                || (this.props.parentList.props.selectedStringIds
                    && this.props.parentList.props.selectedStringIds.indexOf(this.props.model[this.props.idProperty]) > -1)
            ) {
                (checkboxElement as HTMLInputElement).checked = true;
                this.props.selected = true;
            }
            checkboxElement.addEventListener('click', this.handleCheckboxChange);
        }

        if (!this.props.parentList.lastClickedItem) {
            this.props.parentList.lastClickedItem = this;
        }

        if (!this.props.parentList.items.includes(this)) {
            this.props.parentList.items.push(this);
        }

        return this.element;
    }
}